import { Dialog, DialogRef } from '@angular/cdk/dialog';
import { Injectable, inject } from '@angular/core';
import {
  ComponentType,
  ConnectedPosition,
  Overlay
} from '@angular/cdk/overlay';
import { ButtonComponent } from '../../base/button/button.component';

@Injectable({ providedIn: 'root' })
export class PopoutService {
  private readonly _dialog = inject(Dialog);
  private readonly _overlay: Overlay = inject(Overlay);
  private _dialogRef!: DialogRef<unknown, any> | null;

  openPopout<T>(
    button: ButtonComponent,
    contentComponent: ComponentType<T>,
    positions?: ConnectedPosition[] // Optional argument for custom positions
  ): DialogRef<unknown, T> {
    this._dialogRef?.close();

    const top = button.buttonRef.nativeElement.getBoundingClientRect().top + 10; // +10 to move it down towards the icon
    const maxHeight = window.innerHeight - top;

    // Use provided positions or default to positioning the popout to the left of the button
    const defaultPositions: ConnectedPosition[] = [
      {
        originX: 'start', // Anchor to the left of the button
        originY: 'top', // Align to the top of the button
        overlayX: 'end', // Align the right side of the overlay to the left side of the button
        overlayY: 'top', // Align the top of the overlay to the top of the button
        offsetX: -4 // Optional: Add a small gap to the left
      }
    ];

    this._dialogRef = this._dialog.open(contentComponent, {
      id: `${button.id}-popout`,
      hasBackdrop: true,
      backdropClass: 'cdk-overlay-transparent-backdrop',
      positionStrategy: this._overlay
        .position()
        .flexibleConnectedTo(button.buttonRef)
        .withPositions(positions || defaultPositions) // Use custom or default positions
        .withPush(false),
      panelClass: 'dialog-arrow-right',
      maxHeight: maxHeight + 'px'
    });

    this._dialogRef.closed.subscribe((closed) => {
      // stuff to do after close
    });

    return this._dialogRef;
  }
}
